import { Icon } from '@design/components/icon/Icon';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import React, { ReactNode } from 'react';

import { DropdownEntry } from '../dropdown-group/DropdownGroup';
import styles from './DropdownRadioGroup.module.scss';

export type DropdownRadioGroupProps = {
  label?: ReactNode;
  items: DropdownEntry[];
  selectedKey?: string;
};

export const DropdownRadioGroup = ({
  label,
  items,
  selectedKey,
}: DropdownRadioGroupProps) => {
  return (
    <div data-testid="dropdown-radio-group" className={styles.radioGroupWrapper}>
      {label && (
        <RadixDropdown.Label className={styles.label}>
          {label}
        </RadixDropdown.Label>
      )}
      <RadixDropdown.RadioGroup
        value={selectedKey}
        className={styles.radioGroup}
      >
        {items.map(item => (
          <RadixDropdown.RadioItem
            key={item.key}
            className={styles.radioItem}
            value={item.key}
            onSelect={e => item?.onClick?.(e)}
            data-testid={`dropdown-radiogroup-item-${item.key}`}
          >
            <div className={styles.radioItemWrapper}>
              <div className={styles.radioItemSelected} />
              <div className={styles.radioButton}>
                {item.iconName && <Icon iconName={item.iconName} size={16} />}
                <span className={styles.radioItemLabel}>{item.label}</span>
              </div>
            </div>
          </RadixDropdown.RadioItem>
        ))}
      </RadixDropdown.RadioGroup>
      <RadixDropdown.Separator
        data-separator
        className={styles.separator}
      />
    </div>
  );
};
